<template>
  <div class="d-flex justify-content-end">
    <McTableFilter
      :activeFilters="activeFilters"
      :parseFilterDataMappings="parseFilterDataMappings"
      @submit="handleInput"
      @update:showModal="handleShowModalChange"
    >
      <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="alertCode"
            :label="$t('global.field.type')"
            :value="(formValues.alertCode = alertType)"
          >
            <div class="mc-modal__filter-button-group">
              <template v-for="item in alert">
                <button
                  :key="`${item.key}-${alertKey}`"
                  type="button"
                  :class="{ 'mc-modal__filter-button--active': alertType[item.key] }"
                  class="mc-modal__filter-button"
                  @click="filterAlert(item.key)"
                >
                  {{ item.label }}
                </button>
              </template>
            </div>
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-model="period"
            name="period"
            isShow="true"
            :label="$t('landMeasurement.field.tripPeriod')"
            :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
            type="date-picker"
            datepickerType="date"
            valueType="YYYY-MM-DD"
            format="DD MMM YYYY"
            titleFormat="DD MMM YYYY"
            rangeSeparator=" - "
            :range="true"
            :confirm="true"
            :confirmText="$t('global.action.apply')"
            :shortcuts="makeShortcuts"
            validation="required"
            :validation-messages="{
              required: $t('maintenance.validations.required'),
            }"
            :disabled-date="disabledRange"
            @pick="pickDate"
            @close="closePicker"
          >
            <template #help>
              <label class="text-muted fst-italic">
                <span class="text-danger">*</span> {{ $t('maintenance.validations.required') }}
              </label>
            </template>
          </FormulateInput>
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="vehicleFields"
            :fullObject="fullObjects['licensePlate']"
            :value="formValues.licensePlate"
            @update:formValues="updateFormValues({ key: 'licensePlate', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'licensePlate', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            v-bind="driverField"
            :fullObject="fullObjects['drivers']"
            :value="formValues.drivers"
            @update:formValues="updateFormValues({ key: 'drivers', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'drivers', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item">
          <FormulateInput
            type="group"
            name="geolocationType"
            :label="$t('global.object.geolocation')"
            :value="(formValues.geolocationType = geolocationType)"
          >
            <div class="d-flex flex-row">
              <template v-for="option in geolocationTypeOptions">
                <McRadioButton
                  :id="option.key"
                  :key="option.key"
                  v-model="geolocationType"
                  name="geolocationType"
                  :initialValue="option.key"
                  class="geolocation-type-radio"
                >
                  <template #label>
                    <span class="ms-1">{{ option.label }}</span>
                  </template>
                </McRadioButton>
              </template>
            </div>
          </FormulateInput>
          <FormulateInput
            v-bind="geolocationField"
            :fullObject="fullObjects['geolocation']"
            :value="formValues.geolocation"
            class="mt-2"
            :disabled="geolocationType === 'All'"
            :validation="geolocationType !== 'All' ? 'required' : null"
            error-behavior="submit"
            validation-behavior="submit"
            @update:formValues="updateFormValues({ key: 'geolocation', value: $event })"
            @update:fullObject="updateFullObjects({ key: 'geolocation', value: $event })"
          />
        </div>
        <div class="mc-modal__filter-item d-flex gap-2">
          <McCheckbox v-model="formValues.falseAlert" />
          <span>{{ 'False Alert?' }}</span>
        </div>
      </template>
    </McTableFilter>
  </div>
</template>
<script>
import McTableFilter from '@/components/McTableFilter'
import McRadioButton from '@/components/McRadioButton'
import McCheckbox from '@/components/McCheckbox'
import { GET_VEHICLE_FILTER } from '@/services/api/master/fleet'
import { GET_DRIVER_FILTER } from '@/services/api/master/employees'
import { GET_GEOFENCES } from '@/services/api/master/geofence'
import { Helper } from '@/mixin/helper'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McTableFilter,
    McRadioButton,
    McCheckbox,
  },
  mixins: [Helper],
  props: {
    activeFilters: {
      type: Object,
      required: true,
    },
    alertCode: {
      type: Array,
      required: true,
    },
    selectedPeriod: {
      type: Array,
      required: false,
      default: () => [
        moment().subtract(1, 'days').format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD'),
      ],
    },
  },
  emits: ['input', 'update:fullObject'],
  data() {
    return {
      alertType: {
        all: true,
      },
      geolocationType: 'All',
      period: this.selectedPeriod,
      pastDate: moment().subtract(6, 'months'),
      futureEnd: moment().add(6, 'months'),
      currentPastDate: moment().subtract(6, 'months'),
      currentFutureEnd: moment().add(6, 'months'),
      alertKey: 0,
      isModalVisible: false,
    }
  },
  computed: {
    alert() {
      const data = cloneDeep(this.alertCode)
      data.forEach((item) => {
        item.label = this.$t(item.label)
      })
      data.sort((a, b) => {
        let x = a.label.toLowerCase()
        let y = b.label.toLowerCase()
        if (x < y) {
          return -1
        }
        if (x > y) {
          return 1
        }
        return 0
      })
      data.unshift({
        key: 'all',
        alertCode: null,
        label: this.$t('global.filter.all'),
        scope: null,
      })

      return data
    },
    keys() {
      return this.alertCode.map((item) => item.key)
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last3Days'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 72)
            return [date, new Date()]
          },
        },
      ]
    },
    vehicleFields() {
      return {
        name: 'licensePlate',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'id',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: true,
        tableFields: [
          {
            label: this.$t('report.fields.licensePlate'),
            key: 'licensePlate',
            isSortable: true,
          },
          {
            label: this.$t('global.object.fleetCategory'),
            key: 'vehicleType',
            isSortable: false,
            formatter: (value) => {
              return value ? value.category : '-'
            },
          },
          {
            label: this.$t('report.fields.vehicleGroup'),
            key: 'vehicle2Vgroup',
            isSortable: false,
            formatter: (value) => {
              return value && value.length > 0 ? value.map((v) => v.vgroup.name).join(', ') : '-'
            },
          },
        ],
      }
    },
    driverField() {
      return {
        name: 'drivers',
        isShow: true,
        label: this.$t('report.fields.driver'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.driver')}`,
        trackBy: 'id',
        displayedBy: 'fullname',
        listGetter: (filter) => this.getEmployeeList(filter),
        multiple: true,
        tableFields: [
          {
            label: this.$t('report.fields.driver'),
            key: 'fullname',
            isSortable: true,
          },
          {
            label: this.$t('master.form.employee.nip'),
            key: 'employeeIdentifier',
            isSortable: true,
            formatter: (value) => {
              return value ?? '-'
            },
          },
        ],
      }
    },
    geolocationField() {
      return {
        name: 'geolocation',
        isShow: true,
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.geolocation')}`,
        modalTitle: `${this.$t('global.action.choose')} ${this.$t('report.fields.geolocation')}`,
        trackBy: 'geofenceId',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return item.fenceName.toLowerCase().includes(search)
          })
        },
        multiple: true,
        tableFields: [
          {
            label: this.$t('report.fields.geolocation'),
            key: 'fenceName',
            isSortable: true,
          },
          {
            label: this.$t('global.field.category'),
            key: 'category',
            isSortable: true,
            formatter: (value) => {
              return value ?? '-'
            },
          },
          {
            label: this.$t('global.object.city'),
            key: 'city',
            isSortable: true,
            formatter: (value) => {
              return value ?? '-'
            },
          },
        ],
      }
    },
    geolocationTypeOptions() {
      return [
        {
          key: 'All',
          label: this.$t('global.filter.all'),
        },
        {
          key: 'Selection',
          label: this.$t('global.object.inside'),
        },
        {
          key: 'Exclude',
          label: this.$t('global.object.outside'),
        },
      ]
    },
    parseFilterDataMappings() {
      return {
        alertCode: 'alertCode',
        licensePlate: 'vehicleId',
        drivers: 'driverId',
        period: 'period',
        geolocationType: 'geolocationType',
        geolocation: 'geolocationId',
        falseAlert: 'isFalseAlert',
      }
    },
  },
  watch: {
    selectedPeriod: {
      handler(newValue) {
        this.period = newValue
      },
      deep: true,
    },
  },
  methods: {
    async getVehicleList(opt) {
      const { orderBy, ...otherOpt } = opt
      const self = this
      const response = await this.$apollo.query({
        query: GET_VEHICLE_FILTER,
        variables: {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: orderBy ?? JSON.stringify({ licensePlate: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vehiclesFilter.vehiclesFilterPaginated }
      res.data = res.data.map((item) => {
        let status = ''
        if (item.status === 'I') {
          status = self.$t('master.status.aktif')
        } else if (item.status === 'R') {
          status = self.$t('master.status.perbaikan')
        } else {
          status = self.$t('master.status.arsip')
        }
        return Object.assign({}, item, { statusString: status })
      })
      return res
    },
    async getEmployeeList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_DRIVER_FILTER,
        variables: {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: orderBy ?? JSON.stringify({ fullname: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.driversFilter.driversFilterPaginated }

      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.userId,
        }
      })
      return res
    },
    async getGeofenceList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_GEOFENCES,
        variables: {
          filter: {
            orderBy: orderBy ?? JSON.stringify({ fenceName: 'asc' }),
            ownership: ['Own', 'Customer'],
            ...otherOpt,
          },
        },
      })
      const res = response.data.geofences.geofences
      return res
    },
    disabledRange: function (date) {
      let limit = new Date()
      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit
      )
    },
    pickDate(date) {
      const maxDate = 3
      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
    closePicker() {
      this.currentPastDate = moment().subtract(6, 'months')
      this.currentFutureEnd = moment().add(6, 'months')
    },
    handleInput(value) {
      value.map((item) => {
        if (!item.values) {
          if (item.key === 'alertCode') {
            item.values = this.alertCode.flatMap((item) => item.alertCode)
          }
          if (item.key == 'geolocationType') {
            item.values = 'All'
            this.geolocationType = 'All'
          }
          if (item.key == 'period') {
            item.values = this.period
          }
          if (item.key === 'vehicleId' || item.key === 'driverId' || item.key === 'geolocationId') {
            item.values = []
          }
        } else {
          if (item.key === 'alertCode') {
            item.values = this.alertType.all
              ? this.alertCode.flatMap((item) => item.alertCode)
              : this.alertCode
                  .filter((item) => this.alertType[item.key])
                  .flatMap((item) => item.alertCode)
          }
        }
      })
      this.$emit('applyFilters', value)
    },
    filterAlert(key) {
      if (key == 'all') {
        this.alertType = this.alert.reduce((acc, item) => {
          acc[item.key] = false
          return acc
        }, {})
        this.alertType.all = true
      } else {
        this.alertType.all = false
        this.alertType[key] = !this.alertType[key]
        let obj = { ...this.alertType }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })

        if (objArr.length === this.keys.length || objArr.length === 0) {
          this.alertType = this.alert.reduce((acc, item) => {
            acc[item.key] = false
            return acc
          }, {})
          this.alertType.all = true
          return
        }
      }
      this.alertKey += 1
    },
    handleShowModalChange(value) {
      this.isModalVisible = value
      if (!this.isModalVisible && Object.keys(this.activeFilters).length === 0) {
        this.geolocationType = 'All'
      }
    },
  },
}
</script>
